import { useEffect } from 'react';
import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';

import { Right } from '../../../../assets';

export const ScrollArrow = ({
  scrollContainer,
  scrollPos,
  setScrollPos,
  direction = 'up',
}) => {
  const TILE_HEIGHT = 208;
  const { scrollHeight, clientHeight } = scrollContainer;
  const maxScrollHeight = scrollHeight - clientHeight;

  useEffect(() => {
    if (scrollPos === null) setScrollPos(scrollContainer.scrollTop);
  }, [scrollContainer.scrollTop, scrollPos, setScrollPos]);

  const scroll = scrollDirection => {
    const scrollMultipliers = {
      up: -1,
      down: 1,
    };

    const scrollValue = TILE_HEIGHT * scrollMultipliers[scrollDirection];

    scrollContainer.scrollBy({
      top: scrollValue,
      behavior: 'smooth',
    });
  };

  return (
    <Container
      direction={direction}
      $maxScrollHeight={maxScrollHeight}
      $scrollPos={scrollPos}
      onClick={() => scroll(direction)}
    >
      <Arrow
        $scrollPos={scrollPos}
        direction={direction}
        $maxScrollHeight={maxScrollHeight}
        src={Right}
      />
    </Container>
  );
};

const containerUp = css`
  align-items: flex-start;
  top: 115px;
  ${props => props.$scrollPos === 0 && 'display: none;'}
  ${props =>
    props.$scrollPos !== 0 &&
    'background: linear-gradient(180deg, #c8c0c0, transparent 80%) bottom; cursor: pointer;'}
`;

const containerDown = css`
  align-items: flex-end;
  bottom: 0;
  ${props => props.$scrollPos === props.$maxScrollHeight && 'display: none;'}
  ${props =>
    props.$scrollPos !== props.$maxScrollHeight &&
    'background: linear-gradient(0deg, #c8c0c0, transparent 80%) bottom; cursor: pointer;'}
`;

const Container = styled.div`
  width: 100%;
  position: absolute;
  z-index: 99;
  opacity: 0.7;
  display: flex;
  justify-content: center;
  height: 48px;
  ${props => props.direction === 'up' && containerUp};
  ${props => props.direction === 'down' && containerDown};
`;

const Arrow = styled(SVG)`
  grid-area: chevron;
  width: 16px;
  height: 16px;
  transform: ${props =>
    props.direction === 'up' ? 'rotate(-90deg)' : 'rotate(90deg)'};
  margin-left: 4px;
  margin-top: 3px;
  opacity: 0;
  transition: opacity 0.3s;
  ${props =>
    props.$scrollPos !== 0 && props.direction === 'up' ? 'opacity: 1' : ''}
  ${props =>
    props.$scrollPos !== props.$maxScrollHeight && props.direction === 'down'
      ? 'opacity: 1'
      : ''}
`;
